
export const UPDATE_MONITORING = 'monitoring/UPDATE';
export const updateMonitoring = data => ({
  type: UPDATE_MONITORING,
  payload: data,
});

export const RECEIVE_VISITORS = 'monitoring/RECEIVE_VISITORS';
export const receiveVisitors = visitors => ({
  type: RECEIVE_VISITORS,
  payload: visitors,
});

export const RECEIVE_OPERATORS = 'monitoring/RECEIVE_OPERATORS';
export const receiveOperators = operators => ({
  type: RECEIVE_OPERATORS,
  payload: operators,
});

export const RECEIVE_VISITOR_INFO = 'monitoring/RECEIVE_VISITOR_INFO';
export const receiveVisitorInfo = (visitorId, info) => ({
  type: RECEIVE_VISITOR_INFO,
  payload: info,
  meta: { visitorId },
});

export const REMOVE_VISITOR = 'monitoring/REMOVE_VISITOR';
export const removeVisitor = visitorId => ({
  type: REMOVE_VISITOR,
  meta: { visitorId },
});

export const RECEIVE_VISITOR_METRICS = 'monitoring/RECEIVE_VISITOR_METRICS';
export const receiveVisitorMetrics = (visitorId, metrics) => ({
  type: RECEIVE_VISITOR_METRICS,
  payload: metrics,
  meta: { visitorId },
});
